import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/manage/login',
    name: 'Login',
    component: () => import('@/views/user/Login.vue'),
    meta: {
      requiresGuest: true
    }
  },
  {
    path: '/manage/find-id',
    name: 'FindId',
    component: () => import('@/views/user/FindId.vue'),
    meta: {
      requiresGuest: true
    }
  },
  {
    path: '/manage/reset-password',
    name: 'ResetPassword',
    component: () => import('@/views/user/ResetPassword.vue'),
    meta: {
      requiresGuest: true
    }
  },
  {
    path: '/push-subscribe-test',
    name: 'PushSubscribeTest',
    component: () => import('@/views/PushSubscribeTest.vue'),
    meta: {
      title: '푸시 알림 테스트'
    }
  },
  {
    path: '/check-in',
    name: 'CheckIn',
    component: () => import('@/views/guest/CheckIn.vue'),
    meta: {
      requiresGuest: true,
      title: '체크인'
    }
  },
  {
    path: '/pre-check-in',
    name: 'PreCheckIn',
    component: () => import('@/views/guest/PreCheckIn.vue'),
    meta: {
      title: '사전 체크인'
    }
  },
  {
    path: '/pre-check-in/terms',
    name: 'PreCheckInTerms',
    component: () => import('@/views/guest/PreCheckInTerms.vue'),
    meta: {
      requiresAuth: true,
      title: '사전 체크인 - 약관동의'
    }
  },
  {
    path: '/pre-check-in/complete',
    name: 'PreCheckInComplete',
    component: () => import('@/views/guest/PreCheckInComplete.vue'),
    meta: {
      requiresAuth: true,
      title: '사전 체크인 - 완료'
    }
  },
  {
    path: '/pre-check-in/personalize',
    meta: {
      requiresAuth: true,
      title: '사전 체크인 - 맞춤형 서비스 설정'
    },
    children: [
        {
          path: 'index',
          name: 'PreCheckInPersonalize',
          component: () => import('@/views/guest/PreCheckInPersonalize.vue'),
        },
        {
            path: 'question',
            name: 'PreCheckInPersonalizeQuestion',
            component: () => import('@/views/guest/PreCheckInPersonalizeQuestion.vue'),
        }
    ]
  },
  {
    path: '/room/:roomId',
    name: 'RoomGuestService',
    component: () => import('@/layouts/UserLayout.vue'),
    props: true,
    meta: {
      title: '객실 서비스'
    },
      children: [
          {
              path: '',
              name: 'RoomGuest',
              component: () => import('@/views/guest/RoomGuest.vue'),
              props: true,
              meta: {
                  requiresAuth: true,
                  title: '객실 서비스'
              }
          },
          {
              path: 'event',
              name: 'RoomEventList',
              component: () => import('@/views/guest/RoomEventList.vue'),
              props: true,
              meta: {
                  requiresAuth: true,
                  title: 'Event'
              }
          },
          {
              path: 'event/:id',
              name: 'RoomEvent',
              component: () => import('@/views/guest/RoomEvent.vue'),
              props: true,
              meta: {
                  requiresAuth: true,
                  title: 'Event'
              }
          },
          {
              path: 'facility',
              name: 'Facility',
              component: () => import('@/views/guest/Facility.vue'),
              props: true,
              meta: {
                  requiresAuth: true,
                  title: '시설 예약'
              }
          },
          {
              path: 'facility/:id',
              name: 'FacilityView',
              component: () => import('@/views/guest/FacilityView.vue'),
              props: true,
              meta: {
                  requiresAuth: true,
                  title: '시설 예약'
              }
          },
          {
              path: 'facility/:id/reservation',
              name: 'FacilityReservation',
              component: () => import('@/views/guest/FacilityReservation.vue'),
              props: true,
              meta: {
                  requiresAuth: true,
                  title: '시설 예약'
              }
          },

          {
              path: 'order',
              name: 'Order',
              component: () => import('@/views/guest/Order.vue'),
              props: true,
              meta: {
                  requiresAuth: true,
                  title: '스마트 오더'
              }
          },

          {
              path: 'order/checkout',
              name: 'OrderCheckout',
              component: () => import('@/views/guest/OrderCheckout.vue'),
              meta: {
                  requiresAuth: true,
                  title: '스마트 오더'
              }
          },
          {
              path: 'housekeeping',
              name: 'HouseKeeping',
              component: () => import('@/views/guest/HouseKeeping.vue'),
              props: true,
              meta: {
                  requiresAuth: true,
                  title: '하우스 키핑'
              }
          },
          {
              path: 'housekeeping/checkout',
              name: 'HouseKeepingCheckout',
              component: () => import('@/views/guest/HouseKeepingCheckout.vue'),
              props: true,
              meta: {
                  requiresAuth: true,
                  title: '하우스 키핑'
              }
          },
          {
              path: 'nearby',
              name: 'Nearby',
              component: () => import('@/views/guest/Nearby.vue'),
              props: true,
              meta: {
                  requiresAuth: true,
                  title: '정보 안내'
              }
          },{
              path: 'nearby/:id',
              name: 'NearbyView',
              component: () => import('@/views/guest/NearbyView.vue'),
              props: true,
              meta: {
                  requiresAuth: true,
                  title: '정보 안내'
              }
          },
          {
              path: 'notice',
              name: 'RoomNotice',
              component: () => import('@/views/guest/RoomNotice.vue'),
              props: true,
              meta: {
                  requiresAuth: true,
                  title: '공지사항'
              }
          },
          {
              path: 'messages',
              name: 'RoomMessage',
              component: () => import('@/views/guest/RoomMessage.vue'),
              props: true,
              meta: {
                  requiresAuth: true,
                  title: '서비스 알림'
              }
          },
          {
              path: 'info',  // '/room/:roomId/info'
              name: 'RoomInfo',
              component: () => import('@/views/guest/RoomInfo.vue'),
              props: true,
              meta: {
                  requiresAuth: true,
                  title: '객실 이용 안내'
              }
          },
          {
              path: 'amenities',  // '/room/:roomId/amenities'
              name: 'RoomAmenities',
              component: () => import('@/views/guest/RoomAmenities.vue'),
              props: true,
              meta: {
                  requiresAuth: true,
                  title: '객실 비품 안내'
              }
          },
          {
              path: 'evacuation',  // '/room/:roomId/evacuation'
              name: 'RoomEvacuation',
              component: () => import('@/views/guest/RoomEvacuation.vue'),
              props: true,
              meta: {
                  requiresAuth: true,
                  title: '유사시 대피 안내'
              }
          },
          {
              path: 'checkout',
              name: 'RoomCheckout',
              component: () => import('@/views/guest/RoomCheckout.vue'),
              props: true,
              meta: {
                  requiresAuth: true,
                  title: '체크아웃'
              }
          },
          {
              path: 'checkout/late',
              name: 'RoomLateCheckout',
              component: () => import('@/views/guest/RoomLateCheckout.vue'),
              props: true,
              meta: {
                  requiresAuth: true,
                  title: '레이트 체크아웃'
              }
          },
          {
              path: 'my-order',
              name: 'GuestMyOrder',
              component: () => import('@/views/guest/MyOrder.vue'),
              props: true,
              meta: {
                  requiresAuth: true,
                  title: '서비스 이용내역'
              }
          },
          {
              path: 'my-order/:orderNumber',
              name: 'GuestMyOrderDetail',
              component: () => import('@/views/user/MyOrderView.vue'),
              props: true,
              meta: {
                  requiresAuth: true,
                  title: '주문 상세'
              }
          },
      ]
  },

    {
        path: '/room/:roomId/order/complete',
        name: 'OrderComplete',
        component: () => import('@/views/guest/OrderComplete.vue'),
        props: true,
        meta: {
            title: '스마트 오더'
        }
    },
    {
        path: '/room/:roomId/housekeeping/complete',
        name: 'HouseKeepingComplete',
        component: () => import('@/views/guest/HouseKeepingComplete.vue'),
        props: true,
        meta: {
            title: '하우스 키핑'
        }
    },
  {
    path: '/room/:roomId/checkout/complete',
    name: 'RoomLateCheckoutComplete',
    component: () => import('@/views/guest/RoomLateCheckoutComplete.vue'),
    props: true,
    meta: {
      title: '레이트 체크아웃'
    }
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import('@/views/guest/CheckInTerms.vue'),
    meta: {
        title: '약관안내'
    }
  },
  {
    path: '/terms/complete',
    name: 'termsComplete',
    component: () => import('@/views/guest/CheckInTermsComplete.vue'),
    meta: {
        title: '약관안내'
    }
  },
  {
    path: '/manage',
    component: () => import('@/layouts/full/FullLayout.vue'),
    redirect: '/manage/index',
    meta: { 
      requiresAuth: true,
      requiresAdmin: true 
    },
    children: [
      {
        path: 'index',
        name: 'ManageIndex',
        component: () => import('@/views/manage/index.vue'),
        meta:{
          breadcrumbYn: false
        },
      },
      {
        path: 'main-banner',
        name: 'ManageMainBanner',
        redirect: {name:'ManageMainBannerList'},
        meta:{
          title:'이벤트 배너 관리'
        },
        component: () => import('@/layouts/blank/BlankLayout.vue'),
        children:[
          {
            path: '',
            name: 'ManageMainBannerList',
            component: () => import('@/views/manage/main-banner.vue')
          },
          {
            path: 'create',
            name: 'ManageMainBannerCreate',
            meta:{
              title:'이벤트 배너 등록'
            },
            component: () => import('@/views/manage/main-banner-create.vue')
          },
          {
            path: ':id/edit',
            name: 'ManageMainBannerEdit',
            meta:{
              title:'이벤트 배너 수정'
            },
            component: () => import('@/views/manage/main-banner-edit.vue'),
            props: true
          },
        ]
      },
      {
        path: 'room-type',
        name: 'ManageRoomType',
        redirect: {name:'ManageRoomTypeList'},
        meta:{
          title:'객실 유형'
        },
        component: () => import('@/layouts/blank/BlankLayout.vue'),
        children:[
          {
            path: '',
            name: 'ManageRoomTypeList',
            component: () => import('@/views/manage/room-type.vue')
          },
          {
            path: 'create',
            name: 'ManageRoomTypeCreate',
            meta:{
              title:'객실 유형 등록'
            },
            component: () => import('@/views/manage/room-type-create.vue')
          },
          {
            path: ':id/edit',
            name: 'ManageRoomTypeEdit',
            meta:{
              title:'객실 유형 수정'
            },
            component: () => import('@/views/manage/room-type-edit.vue')
          },
        ]
      },
      {
        path: 'rooms',
        name: 'ManageRooms',
        redirect: {name:'ManageRoomsList'},
        meta:{
          title:'객실 관리'
        },
        component: () => import('@/layouts/blank/BlankLayout.vue'),
        children:[
          {
            path: '',
            name: 'ManageRoomsList',
            component: () => import('@/views/manage/rooms.vue')
          },
          {
            path: 'create',
            name: 'ManageRoomsCreate',
            meta:{
              title:'객실 등록'
            },
            component: () => import('@/views/manage/rooms-create.vue')
          },
          {
            path: ':id/edit',
            name: 'ManageRoomsEdit',
            meta:{
              title:'객실 수정'
            },
            component: () => import('@/views/manage/rooms-edit.vue')
          },
        ]
      },
      {
        path: 'staff',
        name: 'ManageStaff',
        redirect: {name:'ManageStaffList'},
        meta:{
          title:'관리자 관리'
        },
        component: () => import('@/layouts/blank/BlankLayout.vue'),
        children:[
          {
            path: '',
            name: 'ManageStaffList',
            component: () => import('@/views/manage/staff.vue')
          },
          {
            path: 'create',
            name: 'ManageStaffCreate',
            meta:{
              title:'관리자 등록'
            },
            component: () => import('@/views/manage/staff-create.vue')
          },
          {
            path: ':id/edit',
            name: 'ManageStaffEdit',
            meta:{
              title:'관리자 수정'
            },
            component: () => import('@/views/manage/staff-edit.vue')
          },
        ]
      },
      {
        path: 'users',
        name: 'ManageUsers',
        redirect: {name:'ManageUserList'},
        meta:{
          title:'고객 정보'
        },
        component: () => import('@/layouts/blank/BlankLayout.vue'),
        children:[
          {
            path: '',
            name: 'ManageUserList',
            component: () => import('@/views/manage/users.vue'),
          },
          {
            path: ':id',
            name: 'UserView',
            meta:{
                title:'고객 정보'
            },
            component: () => import('@/views/manage/users-view.vue')
          },
          {
            path: ':id/edit',
            name: 'UserEdit',
            meta:{
                title:'고객 정보 수정'
            },
            component: () => import('@/views/manage/users-edit.vue')
          },
        ]
      },
      {
        path: 'test/ckeditor',
        name: 'TestCkEditor',
        component: () => import('@/views/test/CkEditorTest.vue')
      },
      {
        path: 'terms',
        name: 'ManageTerms',
        redirect: {name:'ManageTermsList'},
        meta:{
          title:'약관 관리'
        },
        component: () => import('@/layouts/blank/BlankLayout.vue'),
        children:[
          {
            path: '',
            name: 'ManageTermsList',
            component: () => import('@/views/manage/terms.vue')
          },
          {
            path: 'create',
            name: 'ManageTermsCreate',
            meta:{
              title:'약관 등록'
            },
            component: () => import('@/views/manage/terms-create.vue')
          },
          {
            path: ':id/edit',
            name: 'ManageTermsEdit',
            meta:{
              title:'약관 수정'
            },
            component: () => import('@/views/manage/terms-edit.vue')
          },
        ]
      },
      {
        path: 'pre-checkin',
        name: 'ManagePreCheckIn',
        redirect: {name:'ManagePreCheckInList'},
        meta:{
          title:'사전 체크인 현황'
        },
        component: () => import('@/layouts/blank/BlankLayout.vue'),
        children:[
          {
            path: '',
            name: 'ManagePreCheckInList',
            component: () => import('@/views/manage/pre-checkin.vue')
          },
          {
            path: ':id/edit',
            name: 'ManagePreCheckInEdit',
            meta:{
              title:'사전 체크인 상세'
            },
            component: () => import('@/views/manage/pre-checkin-edit.vue'),
            props: true
          },
        ]
      },
      {
        path: 'room-usage',
        name: 'ManageRoomUsage',
        redirect: {name:'ManageRoomUsagePage'},
        meta:{
          title:'객실 이용 현황'
        },
        component: () => import('@/layouts/blank/BlankLayout.vue'),
        children:[
          {
            path: '',
            name: 'ManageRoomUsagePage',
            component: () => import('@/views/manage/room-usage.vue'),
          },
        ]
      },
        {
            path: 'statistics',
            name: 'ManageStatistics',
            meta:{
                title:'고객 데이터 통계'
            },
            redirect: {name:'ManageStatisticsChart'},
            component: () => import('@/layouts/blank/BlankLayout.vue'),
            children:[
                {
                    path: '',
                    name: 'ManageStatisticsChart',
                    component: () => import('@/views/manage/statistics.vue'),
                }
            ]
        },
      {
        path: 'board/setting',
        name: 'ManageBoardSetting',
        redirect: {name:'ManageBoardSettingList'},
        meta:{
          title:'게시판 설정 관리'
        },
        component: () => import('@/layouts/blank/BlankLayout.vue'),
        children:[
          {
            path: '',
            name: 'ManageBoardSettingList',
            component: () => import('@/views/manage/board-setting.vue')
          },
          {
            path: 'create',
            name: 'ManageBoardSettingCreate',
            meta:{
              title:'게시판 등록'
            },
            component: () => import('@/views/manage/board-setting-create.vue')
          },
          {
            path: ':id/edit',
            name: 'ManageBoardSettingEdit',
            meta:{
              title:'게시판 수정'
            },
            component: () => import('@/views/manage/board-setting-edit.vue'),
            props: true
          },
        ]
      },
      {
        path: 'board/:boardUrl',
        name: 'ManageBoardContent',
        component: () => import('@/views/manage/board-content.vue'),
        props: true,
        meta:{
          breadcrumbYn: false
        }
      },
      {
        path: 'board/:boardUrl/create',
        name: 'ManageBoardContentCreate',
        component: () => import('@/views/manage/board-content-create.vue'),
        props: true,
        meta:{
          breadcrumbYn: false
        }
      },
      {
        path: 'board/:boardUrl/:contentId/edit',
        name: 'ManageBoardContentEdit',
        component: () => import('@/views/manage/board-content-edit.vue'),
        props: true,
        meta:{
          breadcrumbYn: false
        }
      },
      {
        path: 'facility',
        name: 'ManageFacility',
        redirect: {name:'ManageFacilityList'},
        meta:{
          title:'시설 정보'
        },
        component: () => import('@/layouts/blank/BlankLayout.vue'),
        children:[
          {
            path: '',
            name: 'ManageFacilityList',
            component: () => import('@/views/manage/facility.vue')
          },
          {
            path: 'create',
            name: 'ManageFacilityCreate',
            meta:{
              title:'시설 정보 등록'
            },
            component: () => import('@/views/manage/facility-create.vue')
          },
          {
            path: ':id/edit',
            name: 'ManageFacilityEdit',
            meta:{
              title:'시설 정보 수정'
            },
            component: () => import('@/views/manage/facility-edit.vue'),
            props: true
          },
          {
            path: ':id/time',
            name: 'ManageFacilityTime',
            meta:{
              title:'시설 예약 시간대 관리'
            },
            component: () => import('@/views/manage/facility-time.vue'),
            props: true
          },
        ]
      },
      {
        path: 'facility/schedule',
        name: 'ManageFacilitySchedule',
        redirect: {name:'ManageFacilityScheduleList'},
        meta:{
          title:'예약 스케줄 관리'
        },
        component: () => import('@/layouts/blank/BlankLayout.vue'),
        children:[
          {
            path: '',
            name: 'ManageFacilityScheduleList',
            component: () => import('@/views/manage/facility-schedule.vue')
          },
          {
            path: 'create',
            name: 'ManageFacilityScheduleCreate',
            meta:{
              title:'예약 스케줄 등록'
            },
            component: () => import('@/views/manage/facility-schedule-create.vue')
          },
          {
            path: ':id/edit',
            name: 'ManageFacilityScheduleEdit',
            meta:{
              title:'예약 스케줄 수정'
            },
            component: () => import('@/views/manage/facility-schedule-edit.vue'),
            props: true
          },
        ]
      },
      {
        path: 'tourism',
        name: 'ManageTourism',
        redirect: {name:'ManageTourismList'},
        meta:{
          title:'주변 정보 관리'
        },
        component: () => import('@/layouts/blank/BlankLayout.vue'),
        children:[
          {
            path: '',
            name: 'ManageTourismList',
            component: () => import('@/views/manage/tourism.vue')
          },
          {
            path: 'create',
            name: 'ManageTourismCreate',
            meta:{
              title:'주변 정보 등록'
            },
            component: () => import('@/views/manage/tourism-create.vue')
          },
          {
            path: ':contentsId/edit',
            name: 'ManageTourismEdit',
            meta:{
              title:'주변 정보 수정'
            },
            component: () => import('@/views/manage/tourism-edit.vue'),
            props: true
          },
        ]
      },
      {
        path: 'product',
        name: 'ManageProduct',
        redirect: {name:'ManageProductList'},
        meta:{
          title:'주문 항목 관리'
        },
        component: () => import('@/layouts/blank/BlankLayout.vue'),
        children:[
          {
            path: '',
            name: 'ManageProductList',
            component: () => import('@/views/manage/product.vue')
          },
          {
            path: 'create',
            name: 'ManageProductCreate',
            meta:{
              title:'주문 항목 등록'
            },
            component: () => import('@/views/manage/product-create.vue')
          },
          {
            path: ':id/edit',
            name: 'ManageProductEdit',
            meta:{
              title:'주문 항목 수정'
            },
            component: () => import('@/views/manage/product-edit.vue'),
            props: true
          },
        ]
      },
      {
        path: 'reservation',
        name: 'ManageReservation',
        redirect: {name:'ManageReservationCalendar'},
        meta:{
          title:'시설 예약 현황'
        },
        component: () => import('@/layouts/blank/BlankLayout.vue'),
        children:[
          {
            path: '',
            name: 'ManageReservationCalendar',
            component: () => import('@/views/manage/facility-reservation.vue')
          },
        ]
      },
      {
        path: 'push-notification',
        name: 'ManagePushNotification',
        redirect: {name:'ManagePushNotificationPage'},
        meta:{
          title:'푸시 알림 관리'
        },
        component: () => import('@/layouts/blank/BlankLayout.vue'),
        children:[
          {
            path: '',
            name: 'ManagePushNotificationPage',
            component: () => import('@/components/admin/PushNotificationAdmin.vue'),
          },
        ]
      },
      {
        path: 'user-requests',
        name: 'ManageUserRequests',
        redirect: {name:'ManageUserRequestsList'},
        meta:{
          title:'사용자 요청 관리'
        },
        component: () => import('@/layouts/blank/BlankLayout.vue'),
        children:[
          {
            path: '',
            name: 'ManageUserRequestsList',
            component: () => import('@/views/manage/user-requests.vue')
          },
          {
            path: ':orderNumber/edit',
            name: 'ManageUserRequestsEdit',
            component: () => import('@/views/manage/user-requests-edit.vue')
          },
        ]
      },
      {
        path: 'payments',
        name: 'ManagePayments',
        redirect: {name:'ManagePaymentsList'},
        meta:{
          title:'예약/결제 내역'
        },
        component: () => import('@/layouts/blank/BlankLayout.vue'),
        children:[
          {
            path: '',
            name: 'ManagePaymentsList',
            component: () => import('@/views/manage/payments.vue')
          },
          {
            path: ':orderNumber',
            name: 'ManagePaymentsDetail',
            meta:{
              title:'예약/결제 내역 상세'
            },
            component: () => import('@/views/manage/payments-view.vue'),
            props: true
          },
        ]
      },
    ]
  },
  {
    path: '/manage/:pathMatch(.*)*',
    name: 'ManageNotFound',
    redirect: '/manage/index'
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    redirect: '/'
  }
]

export const router = createRouter({
  history: createWebHistory(),
  routes
})

// Navigation guards
router.beforeEach((to, from, next) => {
  try {
    const authStore = useAuthStore()

    // Initialize auth state if not already done
    if (!authStore.user && localStorage.getItem('token')) {
      authStore.initializeAuth()
    }

    // Check if route requires authentication
    if (to.meta.requiresAuth && !authStore.isAuthenticated) {
        //관리자 페이지 접근 권한 확인
        if (to.meta.requiresAuth && to.meta.requiresAdmin && !authStore.isAuthenticated) {
            next('/manage/login')
            return
        }

      // Pass roomId as query parameter if accessing /room/:roomId
      if (to.name === 'RoomGuest' && to.params.roomId) {
        next({
          path: '/check-in',
          query: { roomId: to.params.roomId as string }
        })
      } else {
          if (to.path.startsWith('/pre-check-in')) {
              next('/pre-check-in')
              return
          }

        next('/check-in')
      }
      return
    }

    // Check if route requires admin role
    if (to.meta.requiresAdmin && !authStore.isAdmin) {
      next('/')
      return
    }
    
    // Check if route requires guest (not authenticated)
    if (to.meta.requiresGuest && authStore.isAuthenticated) {
      if (authStore.isAdmin) {
        next('/manage/index')
      } else {
        next('/')
      }
      return
    }

    next()
  } catch (error) {
    console.error('Router navigation error:', error)
    next()
  }
})